import { useContext } from 'react';

import { ChatSidebarContext } from './ChatSidebarContextDef';

export const useChatSidebar = () => {
  const context = useContext(ChatSidebarContext);
  if (!context) {
    throw new Error('useChatSidebar must be used within a ChatSidebarProvider');
  }
  return context;
};
